import {TRAVEL_INSURANCES} from "../../constants/constants";

export const getTripProtectionName = (tripProtectionFeeId: string): string => {
    return TRAVEL_INSURANCES[tripProtectionFeeId]?.name;
};
